import React from 'react';


const LoginPage = React.lazy(() => import('./pages/auth/Login'));
const Dashboard = React.lazy(() => import('./pages/dashboard/DashBoardMain'))


const routes = [
  { path: '/', element: <LoginPage />, protected: false },
  { path: '/dashboard', element: <Dashboard />, protected: true },
  
];

export default routes;